export default "__VITE_ASSET__CtnAYpEl__"